import React, { Fragment } from "react";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import { StateContext } from "../../containers/sidebarContext";
import CoverBoxes from "../CoverBoxes";
import { useTranslation } from "react-i18next";

const Wine = () => {
  const state = React.useContext(StateContext);
  const { isSidebarOpen } = state;
  const { t } = useTranslation();

  const champagne = [{ id: 1, title: "MOET ICE", price: "160.00" }];
  //ODVOJITI BOCE I DOZE
  const whiteWine = [
    { id: 1, title: "KOZLOVIC MALVAZIJA", price: "50.00" },
    { id: 2, title: "GALIC GRASEVINA", price: "40.00" },
    { id: 3, title: "STINA CUVEE", price: "40.00" },
    { id: 4, title: "HUGO", price: "6.00" },
    { id: 5, title: "PROSECO", price: "5.00" },
    { id: 6, title: "APEROL SPRITZ", price: "6.50" },
    { id: 7, title: "ROSE WINE", price: "5.00" },
    { id: 8, title: "WHITE WINE", price: "5.00" },
    { id: 9, title: "GEMIST", price: "4.00" },
    { id: 10, title: "BAMBUS", price: "4.00" },
    { id: 11, title: "RED WINE", price: "5.00" },
  ];

  return (
    <Fragment>
      {isSidebarOpen && (
        <>
          <div
            style={{
              backgroundImage: `url(${blackBackground})`,
              backgroundSize: "cover",
            }}
            className="content wine__box"
          >
            <div className="table__header">
              {" "}
              <h2>{t("wine:champagne")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {champagne.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="table__header">
              {" "}
              <h2>{t("wine:wine")}</h2>
            </div>
            <table className="table table-borderless">
              <tbody>
                {whiteWine.map((item) => (
                  <tr key={item.id}>
                    <td>{item.title}</td>
                    <td>{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <CoverBoxes />
        </>
      )}
    </Fragment>
  );
};

export default Wine;
